@if (hotel(); as hotel) {
  <div class="bg-kz-layout-featured">
    <div class="border-bottom p-2">
      <div class="font-semibold flex flex-row gap-1 items-center">
        {{ hotel.hotelName }}
        <app-stars class="pb-1" [stars]="hotel.hotelClass" />
      </div>
      <div class="text-kz-secondary">{{ hotel.cityName }}, {{ hotel.districtName }}</div>
    </div>
    <div class="details-list p-2">
      <div data-testid="hotel-card-nights">
        <mat-icon svgIcon="fill-calendar" color="primary" />
        <!-- R-PLU1 (website-web#164, docs features/website/currency-and-language.md): a count takes the plural form of its number ("3 Ночи", not "3 Ночей") -->
        {{ hotel.checkInDate | date }} — {{ hotel.checkOutDate | date }} ({{
          'NIGHTS_COUNT' | translate: { value: hotel.nights }
        }})
      </div>
      @if (hotel.roomCategoryName) {
        <div>
          <mat-icon svgIcon="fill-bed" color="primary" />
          {{ hotel.roomCategoryName }},
          @if (hotel.placementTypeName) {
            {{ hotel.placementTypeName }}
          }
        </div>
      }
      <div class="flex">
        @if (hotel.mealPlan) {
          <div>
            <mat-icon svgIcon="fill-nutrition" color="primary" />
            {{ hotel.mealPlan }}
          </div>
        }
        @if (hotel.adults) {
          <div data-testid="hotel-card-adults">
            <mat-icon svgIcon="user" color="primary" />
            {{ 'ADULTS_COUNT' | translate: { value: hotel.adults } }}
          </div>
        }
        @if (hotel.children) {
          <div data-testid="hotel-card-children">
            <mat-icon svgIcon="child" color="primary" />
            {{ 'CHILDREN_COUNT' | translate: { value: hotel.children } }}
            @if (hotel._extraParams?.ages) {
              (
              {{ hotel._extraParams.ages.join(', ') }}
              )
            }
          </div>
        }
      </div>
    </div>
  </div>
}
